const useNotification = () => {
  throw new Error('Attempted to call useNotification from RSC');
};

export default useNotification;
